import React from "react";
import Button from "./Button";

const Popup = (props) => {
	const { setIsPopupOpen } = props;
	return (
		<div className="absolute p-4 rounded-lg inset-x-0 top-1/4 w-11/12 lg:w-4/12 m-auto flex flex-col place-items-center text-center font-bold text-xl gap-y-2 drop-shadow-xl bg-black">
			<div className="self-end pb-2 cursor-pointer text-white" onClick={() => setIsPopupOpen(false)}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-6 w-6"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
					strokeWidth={2}>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
					/>
				</svg>
			</div>
			<div className="flex flex-col place-items-center gap-y-3 pb-2 text-white lg:gradient-w-bg">
				<div className="text-3xl">
					<h1>Mint Notice</h1>
				</div>
				<div>
					<p>
						To be able to mint, you must first join the discord and verify by submitting your ETH
						wallet address. Upon verification, you will be able to mint your very own Mōmoku NFT.
					</p>
				</div>
				<Button
					text="Join Discord"
					onClick={() => window.open("https://discord.com/invite/zqmbX52VUX", "_blank")}
					classes={"py-2 mt-2"}
				/>
			</div>
		</div>
	);
};

export default Popup;
